module.exports = __webpack_public_path__ + "img/impacted.5d02b28c.svg";